import styled, { css } from "styled-components";
import FlexBox from "../../../../FlexBox/FlexBox";
import { responsiveMap } from "../../../../Grid/_utils/responsiveObserve";

export const _InnovationProductAdrienCachotRoot = styled(FlexBox)<{}>(
  () => css`
    position: relative;
    z-index: 1;
    overflow: hidden;
    flex-direction: column;

    /* ─── Desktop : vidéo en flow avec aspect-ratio, textes en dessous, bouton au hover ─── */
    .innovation-adrien-cachot-product-video {
      position: relative;
      width: 100%;
      height: 100%;
      /* aspect-ratio donne la hauteur à partir de la largeur, sans dépendre du parent */
      aspect-ratio: 437 / 523;
      flex-shrink: 0;

      /* Le wrapper SushishopVideo a height: 100% — le forcer à remplir */
      .sushishop-video__wrapper {
        height: 100%;
      }

      video,
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .innovation-adrien-cachot-product-content {
      position: relative;
      z-index: 2;
      flex-shrink: 0;
      align-items: flex-start;
      padding: 31px 0 100px;
      max-width: 100%;
      width: 100%;
      margin: 0;

      * {
        text-align: left;
      }
    }

    /* Bouton caché par défaut, visible au hover sur la carte */
    .innovation-adrien-cachot-product-action-button {
      opacity: 0;
      transition: opacity 0.3s ease-out;
    }

    &:hover .innovation-adrien-cachot-product-action-button {
      opacity: 1;
    }

    /* ─── Mobile : vidéo en background, contenu en overlay aligné à gauche ─── */
    @media ${responsiveMap.mobile} {
      aspect-ratio: 361 / 560;
      background-color: #000;

      .innovation-adrien-cachot-product-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .innovation-adrien-cachot-product-content {
        position: relative;
        z-index: 2;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 24px;
        max-width: 100%;
        width: 100%;
        height: 100%;
        margin: 0;
        background-color: transparent;
        * {
          text-align: left;
        }
      }

      .innovation-adrien-cachot-product-action-button {
        width: 100%;
        opacity: 1;
      }
    }
  `
);
